// @spec SUP-STR-023
'use client';

import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuestionnaireReviewPage } from '@/features/suppliers/review';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/suppliers/questionnaires/$sentId/review')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.reviewQuestionnaire'),
  }),
  component: ReviewRoute,
});

function ReviewRoute() {
  const { sentId } = useParams({
    from: '/_authenticated/suppliers/questionnaires/$sentId/review',
  });

  return <QuestionnaireReviewPage sentId={sentId} />;
}
